"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Quoterequestwhatsapp() {
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: captionRef,
    isVisible: captionVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  return <section data-section-id="4535" id="quoterequestwhatsapp" className="bg-background text-foreground relative w-full overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/industrial_steel_foundry.png)]" />

      {}
      <div className="absolute inset-0" style={{
      background: "linear-gradient(135deg, hsla(125, 55%, 10%, 0.9) 0%, hsla(125, 55%, 24%, 0.7) 50%, hsla(125, 55%, 10%, 0.85) 100%)"
    }} />

      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.12] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      <div className="relative z-10 mx-auto flex max-w-[800px] flex-col items-center px-6 py-32 text-center md:py-44 lg:py-[180px]">
        {}
        <div ref={labelRef} className={`mb-12 transition-all duration-700 ease-out md:mb-16 ${labelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-mono text-xs tracking-[0.25em] text-primary-foreground/90 uppercase">
            05 — Contacto
          </span>
        </div>

        {}
        <h2 ref={headingRef} className={`font-default text-primary-foreground leading-[0.95] tracking-tight transition-all duration-1000 ease-out ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        fontWeight: 700,
        fontSize: "clamp(3.5rem, 10vw, 8.75rem)"
      }}>FORJA TU<span className="inline-flex items-center px-3 align-middle md:px-5" data-ast-id="f:/src/pages/Catalog/sections/Quoterequestwhatsapp.tsx|sig:rq5b6w" data-ast-start="2701" data-ast-end="2961"><span className="inline-block h-[2px] bg-accent" data-ast-id="f:/src/pages/Catalog/sections/Quoterequestwhatsapp.tsx|sig:s0xqyj" data-ast-start="2783" data-ast-end="2943" style={{
            width: 'clamp(2.5rem, 6vw, 5rem)',
            transform: 'rotate(-15deg)'
          }}></span></span>PROYECTO.</h2>

        {}
        <p ref={bodyRef} className={`mt-10 max-w-[560px] text-base leading-relaxed text-primary-foreground/90 transition-all duration-1000 delay-150 ease-out md:text-lg font-default ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          Cada gran estructura comienza con una alianza sólida. Comparta sus requerimientos técnicos y objetivos de obra; nuestro equipo de expertos le brindará una cotización personalizada en menos de 24 horas.
        </p>

        {}
        <div ref={ctaRef} className={`mt-12 flex flex-col items-center gap-6 transition-all duration-1000 delay-300 ease-out sm:flex-row sm:gap-8 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Button asChild size="lg" className="group h-auto rounded-lg bg-accent px-8 py-4 text-base font-semibold text-accent-foreground shadow-lg hover:bg-accent/90 transition-colors">
            <Link to="https://wa.me/526149800517" newTab>
              Solicitar Cotización
              <ArrowRight className="ml-1 size-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>

          
        </div>

        {}
        <p ref={captionRef} className={`mt-16 font-mono text-[11px] tracking-[0.2em] text-primary-foreground/70 uppercase transition-all duration-1000 delay-500 ease-out md:text-xs ${captionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          Respuesta Inmediata — Cobertura Nacional / Centros de Distribución Kalisch
        </p>
      </div>
    </section>;
}